export const vc_task_types = [
    { code: '1', label: 'Reading' },
    { code: '2', label: 'Improvization' },
    { code: '3', label: 'Emotion' },
];